import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, Inject, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnChatUser } from '@lib/communication/twiliochat/models';
import { SnFormFieldConfig } from 'libs/form/src/lib/types/form-field-config.type';
import { t } from '@lib/translation';

import { SnMembersService } from '../../../services/members.service';

@Component({
  selector: 'sn-edit-member-expiration',
  templateUrl: './edit-member-expiration.component.html',
  styleUrls: ['./edit-member-expiration.component.scss'],
})
export class EditMemberExpirationComponent implements OnInit, OnDestroy {
  public form = new UntypedFormGroup({});
  public formModel: any = {};
  public formFields: SnFormFieldConfig[] = [
    {
      key: 'expirationTimestamp',
      type: 'datetimepicker',
      templateOptions: {
        placeholder: t('communication.chat.expirationDateTime'),
        required: true,
        minDate: () => new Date(),
      },
    },
  ];

  private readonly _destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      sid: string;
      user: SnChatUser;
    },
    private readonly _membersService: SnMembersService,
    private readonly _dialogRef: MatDialogRef<EditMemberExpirationComponent>,
    private readonly _cd: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this.formModel.expirationTimestamp = this.data.user.expirationTimestamp;
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public onSubmit(): void {
    this._membersService
      .updateMember(this.data.sid, this.data.user.id, this.formModel)
      .pipe(takeUntil(this._destroy$))
      .subscribe((response) => {
        this._dialogRef.close(response?.expirationTimestamp);
        this._cd.detectChanges();
      });
  }
}
